import { ApplicantInterface, FundsAllowDetailsInterface, FundsAllowInterface, ScholarshipSummaryInterface } from "../types/types";

// Action Types
export const APPLICATION_MANAGE_INFO = "APPLICATION_MANAGE_INFO";
export const FUND_ALLOWCATION = "FUND_ALLOWCATION";
export const FUND_ALLOWCATION_DETAILS = "FUND_ALLOWCATION_DETAILS";
export const SCHOLARSHIP_SUMMARY_DETAILS = "SCHOLARSHIP_SUMMARY_DETAILS";

// State Interface

export interface AppState {
  applicationManageData: ApplicantInterface[];
  fundAllocation: FundsAllowInterface[];
  fundAllocationDetails: FundsAllowDetailsInterface[];
  ScholarshipSummaryDetails: ScholarshipSummaryInterface[]
}

interface ApplicationMaangeAction {
  type: typeof APPLICATION_MANAGE_INFO;
  payload: any;
}

interface FundsAllowAction {
  type: typeof FUND_ALLOWCATION;
  payload: any;
}

interface FundsAllowListAction {
  type: typeof FUND_ALLOWCATION_DETAILS;
  payload: any;
}

interface ScholarshipSummaryAction {
  type: typeof SCHOLARSHIP_SUMMARY_DETAILS;
  payload: any;
}

export type ActionTypes = ApplicationMaangeAction | FundsAllowAction | FundsAllowListAction | ScholarshipSummaryAction;
